import { AuiChartBase } from './AuiChartBase';
import type { AuiRendererProps } from '../../registry';

export function AuiAreaChart(props: AuiRendererProps) {
  return <AuiChartBase {...props} testId="aui-area-chart" />;
}
